import { get } from '../Services/ApiClient';

interface UseWizardTreeProps {
	wizardKey: string;
	params?: any;
}

const useWizardTree = (props: UseWizardTreeProps) => {
	const { wizardKey, params } = props;

	const handleGet = async () => {
		const urlParams = params ? new URLSearchParams(params).toString() : '';

		const result = await get(`/wizard/${wizardKey}/tree?${urlParams}`);

		return result?.data || [];
	};

	const handleGetStructure = async () => {
		const urlParams = params ? new URLSearchParams(params).toString() : '';

		const result = await get(`/wizard/${wizardKey}/structure?${urlParams}`);

		return result?.data || [];
	};

	return {
		getWizard: handleGet,
		getWizardStructure: handleGetStructure,
	};
};

export default useWizardTree;
